<mat-table [dataSource]="tableData()" class="mat-elevation-z4 mt-3">
	@for (item of columns(); track item.id) {
		<ng-container [matColumnDef]="item.id">
			<mat-header-cell *matHeaderCellDef>{{ item.name }}</mat-header-cell>
			<mat-cell *matCellDef="let element">
				@if (!isLegacyMode() && item.id === 'amount') {
					{{ element[item.id] | priceCurrency: 'PLN' }}
				} @else {
					{{ element[item.id] }}
				}
			</mat-cell>
		</ng-container>
	}
	<mat-header-row *matHeaderRowDef="tableKeys()"></mat-header-row>
	<mat-row *matRowDef="let row; columns: tableKeys()"></mat-row>
</mat-table>
